/* نافذة أرقام الدعم — مستقلة عن عنصر المنتج، تفويض أحداث على المستند. */
(function () {
  if (window.__alnashirSupport) return;
  window.__alnashirSupport = true;

  var lastFocus = null;

  function open(modal) {
    lastFocus = document.activeElement;
    modal.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';
    var first = modal.querySelector('.apx-modal-x');
    if (first) first.focus();
  }

  function close(modal) {
    modal.classList.remove('is-open');
    document.documentElement.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-apx-support-open]');
    if (opener) {
      var id = opener.getAttribute('data-apx-support-open');
      var modal = document.getElementById(id);
      if (modal) { e.preventDefault(); open(modal); }
      return;
    }

    if (e.target.closest('[data-apx-support-close]') || e.target.classList.contains('apx-modal-veil')) {
      var box = e.target.closest('.apx-modal');
      if (box) close(box);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var openModal = document.querySelector('.apx-modal.is-open');
    if (openModal) close(openModal);
  });
})();
